export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_CONFIRMATION = 'RESET_PASSWORD_CONFIRMATION';
export const RESET_PASSWORD_SUBMIT = 'RESET_PASSWORD_SUBMIT';
export const RESET_PASSWORD_SUBMIT_CONFIRMATION = 'RESET_PASSWORD_SUBMIT_CONFIRMATION';